import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Select } from '@app/components/common/selects/Select/Select';
import { Modal } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IUser } from '@app/interfaces/user';

interface ChatInputFilterModalProps {
  open: boolean;
  onCancel: () => void;
  onSubmit: (values: { users: string[] }) => void;
  users: IUser[];
  values?: {
    users: string[];
  };
  loader: boolean;
}

export const ChatInputFilterModal: React.FC<ChatInputFilterModalProps> = ({
  open,
  onCancel,
  onSubmit,
  users,
  values,
  loader,
}) => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();

  const channelFormValues = useMemo(
    () => ({
      users: values?.users || [],
    }),
    [values],
  );

  const onOk = () => {
    form.submit();
  };

  return (
    <Modal
      title={t('chats.filters')}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={t('chats.filter')}
      cancelText={t('common.cancel')}
      confirmLoading={loader}
    >
      <BaseForm initialValues={channelFormValues} form={form} layout="vertical" name="channelForm" onFinish={onSubmit}>
        <BaseForm.Item name="users" label={t('chats.users')}>
          <Select
            showSearch
            filterOption={(input, option) => option?.name?.toLowerCase().includes(input.toLowerCase())}
            placeholder={t('chats.users')}
            mode="multiple"
            options={users}
          />
        </BaseForm.Item>
      </BaseForm>
    </Modal>
  );
};
